import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../assets/css/addunit.css";
import "../../assets/css/mainMenu.css";
import edit from "../../assets/icons/edit.svg";

import close from "../../assets/icons/close.svg";

import recyclebin from "../../assets/icons/recycle-bin2.svg";

import ArrowDown from "../../assets/icons2/ArrowDown.svg";
import ArrowUp from "../../assets/icons2/ArrowUp.svg";
import plus1 from "../../assets/icons/plus1.svg";
import search2 from "../../assets/icons/search2.svg";
import Loader from "../../Components/LoaderAndSpinner/Loader";
import fetchWrapper from "../../AuthMiddleware/FetchWrapper";
import { useNavigate } from "react-router-dom";
import Pagination from "../../Components/Pagination/Pagination";
import { hasPermission } from "../../Services/authUtils";

const RoleGroup = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [roleGroups, setRoleGroups] = useState([]);
  const [newRoleGroup, setNewRoleGroup] = useState({
    role_group_code: "",
    role_group_name: "",
  });
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedRoleGroup, setSelectedRoleGroup] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const [actionType, setActionType] = useState(null);
  const [actionGroupId, setActionGroupId] = useState(null);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sortBy, setSortBy] = useState({
    field: "role_group_code",
    order: "asc",
  });
  const [statusFilter, setStatusFilter] = useState("");

  const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [allChecked, setAllChecked] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);
  const [bulkDeleteModal, setBulkDeleteModal] = useState(false);
  const [errors, setErrors] = useState({});
  // const [errorMessage, setErrorMessage] = useState("");

  const startIndex = (page - 1) * pageSize + 1;
  const endIndex = Math.min(page * pageSize, totalItems);

  const fetchRoleGroups = async () => {
    const queryString = `?page=${page}&limit=${pageSize}&sortBy=${sortBy.field}&order=${sortBy.order}&search=${search}&status=${statusFilter}`;
    try {
      const data = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/role-groups/pagination${queryString}`,
        { method: "POST" },
        navigate // Pass navigate here
      );
      setRoleGroups(data.roleGroups);
      setTotalPages(data.totalPages);
      setCurrentPage(data.currentPage);
      setTotalItems(data.totalItems);
    } catch (error) {
      console.error("Error fetching role groups:", error);
    }
  };

  const handleSortChange = (field) => {
    setSortBy((prevSort) => ({
      field,
      order:
        prevSort.field === field && prevSort.order === "asc" ? "desc" : "asc",
    }));
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  const handleAddRoleGroup = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});
    // setErrorMessage("");

    const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/role-groups/create`;

    try {
      const data = await fetchWrapper(
        apiUrl,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newRoleGroup),
        },
        navigate // Pass navigate here if needed
      );

      setLoading(false);
      setRoleGroups((prevRoleGroups) => [...prevRoleGroups, data]);
      setNewRoleGroup({ role_group_code: "", role_group_name: "" });
      setShowAddModal(false);
      toast.success("Role group added successfully");
      fetchRoleGroups(); // Fetch updated role groups
    } catch (error) {
      setLoading(false); // Ensure loading state is reset in case of an error
      if (error.response) {
        const errorData = error.response;
        console.error(errorData);
        setErrors(errorData.errors || {});
        // setErrorMessage(errorData.message || "Error adding role group");
        toast.error(errorData.message || "Error adding role group");
      } else {
        console.error("Error adding role group:", error);
        toast.error("Error adding role group");
      }
    }
  };

  const handleDeleteRestore = (groupId, currentStatus) => {
    setActionGroupId(groupId);
    setActionType(currentStatus ? "Inactive" : "Restore");
    setConfirmModal(true);
  };

  const confirmAction = async () => {
    setLoading(true);
    let url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/rolegroups/delete/${actionGroupId}`;

    // If the action type is restore, update the URL

    try {
      await fetchWrapper(url, { method: "POST" }, navigate);

      // Update the status of the role group
      const updatedRoleGroups = roleGroups.map((roleGroup) =>
        roleGroup._id === actionGroupId
          ? { ...roleGroup, status: actionType === "Inactive" ? false : true }
          : roleGroup
      );

      setRoleGroups(updatedRoleGroups);
      setConfirmModal(false);
      if (actionType === "Inactive") {
        toast.success(`Role Group Inactive Successful`);
      } else {
        toast.success(`Role Group Restore Successful`);
      }
    } catch (error) {
      console.error(`Error ${actionType} role group:`, error);
      toast.error(`Error ${actionType} role group`);
    } finally {
      setLoading(false);
    }
  };

  const handleBulkDelete = async () => {
    setLoading(true);
    const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/rolegroups/delete/${checkedItems[0]}`;

    try {
      await fetchWrapper(
        url,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ids: checkedItems,
          }),
        },
        navigate
      );



      const updatedRoleGroups = roleGroups.map((roleGroup) =>
        checkedItems.includes(roleGroup._id)
          ? { ...roleGroup, status: false }
          : roleGroup
      );

      setRoleGroups(updatedRoleGroups);
      setBulkDeleteModal(false);
      toast.success(`All the selected items are Inactivated `);

      setAllChecked(false);
      setCheckedItems([]);
    } catch (error) {
      console.error(`Error deleting selected role groups:`, error);
      toast.error(`Error deleting selected role groups`);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateRoleGroup = async (roleId, updatedData) => {
    setLoading(true);
    setErrors({});
    // setErrorMessage("");

    if (!roleId) {
      console.error("Role group ID is undefined");
      setLoading(false);
      return;
    }

    try {
      const data = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/role-groups/update/${roleId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedData),
        },
        navigate // Pass navigate here if needed
      );

      const updatedRoleGroups = roleGroups.map((roleGroup) => {
        if (roleGroup._id === roleId) {
          return { ...roleGroup, ...data };
        }
        return roleGroup;
      });

      setLoading(false);
      setRoleGroups(updatedRoleGroups);
      toast.success("Role Group updated successfully");
      setShowEditModal(false);
    } catch (error) {
      setLoading(false); // Ensure loading state is reset in case of an error
      if (error.response) {
        const errorData = error.response;
        console.error(errorData);
        setErrors(errorData.errors || {});
        // setErrorMessage(errorData.message || "Error updating role group");
        toast.error(errorData.message || "Error updating role group");
      } else {
        console.error("Error updating role group:", error);
        toast.error("Error updating role group");
      }
    }
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      setPage(page);
      // Add any additional logic for page change here
    }
  };

  // Calculate the page numbers to display

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setPage(1);
  };
  const handleStatusChange = (status) => {
    setStatusFilter(status === "all" ? "" : status);
    setPage(1); // Reset to the first page when changing status
  };

  const handleHeaderCheckboxChange = () => {
    const newCheckedStatus = !allChecked;
    setAllChecked(newCheckedStatus);
    if (newCheckedStatus) {
      setCheckedItems(
        roleGroups
          .filter((roleGroup) => roleGroup.status)
          .map((roleGroup) => roleGroup._id)
      );
    } else {
      setCheckedItems([]);
    }
  };

  const handleRowCheckboxChange = (roleGroupId) => {
    setCheckedItems((prevCheckedItems) => {
      const isChecked = prevCheckedItems.includes(roleGroupId);
      const updatedCheckedItems = isChecked
        ? prevCheckedItems.filter((id) => id !== roleGroupId)
        : [...prevCheckedItems, roleGroupId];

      setAllChecked(
        updatedCheckedItems.length ===
        roleGroups.filter((roleGroup) => roleGroup.status).length
      );
      return updatedCheckedItems;
    });
  };

  useEffect(() => {
    fetchRoleGroups();
  }, [
    page,
    pageSize,
    sortBy,
    // search,
    //totalPages,
    // currentPage,
    //totalItems,
    showEditModal,
    statusFilter,
  ]);
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default behavior if needed
      fetchRoleGroups(); // Perform search
    }
  };

  return (
    <>
      <div className="">
        <div className="container">
          <div className="show-breadcrumb pt-3">
            <div className="d-flex">
              <h5 className="">Role Groups</h5>
            </div>
            <nav className="breadcrumb-nav" aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item ">
                  <a className="">Configure</a>
                </li>
                <li className="breadcrumb-item">
                  <a className="">User Settings</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Role Groups
                </li>
              </ol>
            </nav>

            <div className="">
              <div
                className="navbar-3 d-flex justify-content-between"
                style={{ marginTop: "-3px" }}
              >
                <div className="d-flex gap-3">
                  <div className="search-container ">
                    <img src={search2} alt="Search" />
                    <input
                      type="text"
                      className=""
                      id="search"
                      value={search}
                      onChange={handleSearchChange}
                      onKeyDown={handleKeyDown}
                      placeholder="Search "
                      name="search"
                      autoComplete="off"
                    />
                  </div>
                  {hasPermission(["roleGroups.delete"]) && (
                    <div>
                      {checkedItems.length > 0 && (
                        <button
                          id="bulkDelete"
                          className="bulkDelete-btn"
                          style={{ display: "block" }}
                          onClick={() => setBulkDeleteModal(true)}
                        >
                          <span>
                            <img
                              src={recyclebin}
                              height="24px"
                              width="24px"
                              alt=""
                            />
                          </span>{" "}
                          Inactive
                        </button>
                      )}
                    </div>
                  )}
                </div>

                <div className="d-flex gap-3">
                  <div className="dropdown">
                    <select
                      id="cars"
                      className=" select-unit textarea "
                      value={statusFilter}
                      onChange={(e) => handleStatusChange(e.target.value)}
                      style={{
                        width: "120px",
                        height: "48px", // Adjust height to be 3px less
                      }}
                    >
                      <option value="">All</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </div>

                  {hasPermission(["roleGroups.create"]) && (
                    <div>
                      <button
                        type="button"
                        id="openPopup"
                        className="btn-bg"
                        style={{ height: "3rem", width: "15rem" }}
                        onClick={() => {
                          setErrors({});
                          setShowAddModal(true);
                        }}
                      >
                        <span className="plus-icon">
                          <img src={plus1} alt="Plus Icon" />
                        </span>
                        Add Role Group
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <div style={{ marginTop: "-10px" }}>
                <div className="table-responsive">
                  <table className="table  align-middle table-text ">
                    <thead className="table-head align-middle">
                      <tr>
                        <th className="table-check">
                          <input
                            type="checkbox"
                            checked={allChecked}
                            onChange={handleHeaderCheckboxChange}
                          />
                        </th>
                        <th className="col">ID</th>
                        <th
                          className="col"
                          onClick={() => handleSortChange("role_group_code")}
                        >
                          CODE{" "}
                          {sortBy.field === "role_group_code" && (
                            <span>
                              {sortBy.order === "asc" ? (
                                <img src={ArrowUp} alt="ArrowUp" />
                              ) : (
                                <img src={ArrowDown} alt="ArrowDown" />
                              )}
                            </span>
                          )}
                        </th>
                        <th
                          className="col"
                          onClick={() => handleSortChange("role_group_name")}
                        >
                          NAME{" "}
                          {sortBy.field === "role_group_name" && (
                            <span>
                              {sortBy.order === "asc" ? (
                                <img src={ArrowUp} alt="ArrowUp" />
                              ) : (
                                <img src={ArrowDown} alt="ArrowDown" />
                              )}
                            </span>
                          )}
                        </th>
                        <th className="col"> STATUS</th>

                        {(hasPermission(["roleGroups.update"]) ||
                          hasPermission(["roleGroups.delete"])) && (
                            <th className="col">ACTION</th>
                          )}
                      </tr>
                    </thead>
                    <tbody>
                      {roleGroups.map((roleGroup, index) => (
                        <tr
                          key={roleGroup._id}
                          className={
                            roleGroup.status ? "" : " disabled text-muted"
                          }
                        >
                          <td className="table-check">
                            <input
                              type="checkbox"
                              checked={checkedItems.includes(roleGroup._id)}
                              onChange={() =>
                                handleRowCheckboxChange(roleGroup._id)
                              }
                              disabled={!roleGroup.status}
                            />
                          </td>

                          <td>{index + startIndex}</td>

                          <td>{roleGroup.role_group_code}</td>
                          <td>{roleGroup.role_group_name}</td>
                          <td>
                            {roleGroup.status ? (
                              <span className="active-status">Active</span>
                            ) : (
                              <span className="inactive">Inactive</span>
                            )}
                          </td>
                          {(hasPermission(["roleGroups.update"]) ||
                            hasPermission(["roleGroups.delete"])) && (
                              <td>
                                <div className="action-icons d-flex justify-content-left align-items-center">
                                  {roleGroup.status &&
                                    hasPermission(["roleGroups.update"]) && (
                                      <button
                                        style={{
                                          border: "none",
                                          background: "transparent",
                                        }}
                                        className="align-content-center me-3"
                                        onClick={() => {
                                          setErrors({});
                                          if (roleGroup.status) {
                                            setSelectedRoleGroup(roleGroup);
                                            setShowEditModal(true);
                                          }
                                        }}
                                        disabled={!roleGroup.status}
                                      >
                                        <img src={edit} alt="edit" />
                                      </button>
                                    )}
                                  {hasPermission(["roleGroups.delete"]) && (
                                    <span className="align-content-center switcher">
                                      <label className="switch switch1">
                                        <input
                                          type="checkbox"
                                          id={`customSwitch${roleGroup._id}`}
                                          checked={roleGroup.status}
                                          onChange={() =>
                                            handleDeleteRestore(
                                              roleGroup._id,
                                              roleGroup.status
                                            )
                                          }
                                        />
                                        <span className="slider slider1 round"></span>
                                      </label>
                                    </span>
                                  )}
                                </div>
                              </td>
                            )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                pageSize={pageSize}
                onPageSizeChange={handlePageSizeChange}
                totalItems={totalItems}
                startIndex={startIndex}
                endIndex={endIndex}
              />
            </div>
          </div>
          {/* Add Modal Content */}
          <div
            id="overlay"
            className={`modal  ${showAddModal ? "show" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{
              zIndex: 30,
              display: showAddModal ? "block" : "none",
              transition: "width 2s",
            }}
          >
            {loading ? (
              <Loader />
            ) : (
              <div className="addunit-card Width 25%">
                <div className="addunit-header">
                  <h4>Add Role Group</h4>

                  <button
                    style={{ border: "none", backgroundColor: "inherit" }}
                    type="button"
                    className="close"
                    onClick={() => {
                      setNewRoleGroup({
                        role_group_code: "",
                        role_group_name: "",
                      });
                      setShowAddModal(false);
                    }}
                  >
                    <img src={close} width="28px" height="28px" alt="Close" />
                  </button>
                </div>

                <form
                  onSubmit={handleAddRoleGroup}
                  noValidate
                  className="needs-validation"
                >
                  <div className="addunit-form">
                    <div className="row ">
                      <div className="col-sm-6">
                        <div className="d-flex flex-column mb-4">
                          <label htmlFor="code" className="addunit-form-text">
                            Role Group Code{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${errors.role_group_code ? "is-invalid" : ""
                              }`}
                            id="validationCustomUsername"
                            placeholder="Enter code"
                            value={newRoleGroup.role_group_code}
                            onChange={(e) =>
                              setNewRoleGroup({
                                ...newRoleGroup,
                                role_group_code: e.target.value,
                              })
                            }
                          />
                          {errors.role_group_code && (
                            <div className="invalid-feedback">
                              {errors.role_group_code}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="d-flex flex-column mb-4">
                          <label htmlFor="name" className="addunit-form-text">
                            Role Group Name{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${errors.role_group_name ? "is-invalid" : ""
                              }`}
                            placeholder="Enter Name"
                            id="name"
                            value={newRoleGroup.role_group_name}
                            onChange={(e) =>
                              setNewRoleGroup({
                                ...newRoleGroup,
                                role_group_name: e.target.value,
                              })
                            }
                          />
                          {errors.role_group_name && (
                            <div className="invalid-feedback">
                              {errors.role_group_name}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="addunit-card-footer justify-content-between">
                    <button
                      type="button"
                      className="discard-btn "
                      onClick={() => {
                        setNewRoleGroup({
                          role_group_code: "",
                          role_group_name: "",
                        });
                        setShowAddModal(false);
                      }}
                    >
                      Close
                    </button>
                    <button type="submit" className="update-btn ">
                      Add
                    </button>
                  </div>
                </form>
              </div>
            )}
          </div>

          {/* Edit Modal Content */}
          <div
            id="overlay"
            className={`modal fade ${showEditModal ? "show" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{
              zIndex: 30,
              display: showEditModal ? "block" : "none",
              transition: "width 2s",
            }}
          >
            {loading ? (
              <Loader />
            ) : (
              <div>
                <div className="addunit-card Width 25%">
                  <div className="addunit-header">
                    <h4>Edit Role Group</h4>
                    <button
                      style={{ border: "none", backgroundColor: "inherit" }}
                      type="button"
                      className="close"
                      onClick={() => setShowEditModal(false)}
                    >
                      <img src={close} width="28px" height="28px" alt="Close" />
                    </button>
                  </div>
                  {selectedRoleGroup && (
                    <form noValidate className="needs-validation">
                      <div className="addunit-form">
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="d-flex flex-column mb-4">
                              <label
                                htmlFor="editCode"
                                className="addunit-form-text"
                              >
                                Role Group Code
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                className={`form-control ${errors.role_group_code ? "is-invalid" : ""
                                  }`}
                                placeholder="Enter code"
                                id="validationCustomUsername"
                                value={selectedRoleGroup?.role_group_code || ""}
                                onChange={(e) =>
                                  setSelectedRoleGroup({
                                    ...selectedRoleGroup,
                                    role_group_code: e.target.value,
                                  })
                                }
                              />
                              {errors.role_group_code && (
                                <span className="invalid-feedback">
                                  {errors.role_group_code}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="d-flex flex-column mb-4">
                              <label
                                htmlFor="editName"
                                className="addunit-form-text"
                              >
                                Role Group Name
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                className={`form-control ${errors.role_group_name ? "is-invalid" : ""
                                  }`}
                                placeholder="Enter name"
                                id="editName"
                                value={selectedRoleGroup?.role_group_name || ""}
                                onChange={(e) =>
                                  setSelectedRoleGroup((prevRoleGroup) => ({
                                    ...prevRoleGroup,
                                    role_group_name: e.target.value,
                                  }))
                                }
                              />
                              {errors.role_group_name && (
                                <span className="invalid-feedback">
                                  {errors.role_group_name}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  )}
                  <div className="addunit-card-footer">
                    <button
                      type="button"
                      className="discard-btn"
                      onClick={() => setShowEditModal(false)}
                    >
                      Close
                    </button>
                    <button
                      type="button"
                      className="update-btn"
                      onClick={() =>
                        handleUpdateRoleGroup(
                          selectedRoleGroup?._id,
                          selectedRoleGroup
                        )
                      }
                    >
                      Save Changes
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Confirmation Modal Content */}
          <div
            id="overlay"
            className={`modal fade ${confirmModal ? "show" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{
              zIndex: 30,
              display: confirmModal ? "block" : "none",
              transition: "width 2s",
            }}
          >
            {loading ? (
              <Loader />
            ) : (
              <div>
                <div className="addunit-card Width 25%">
                  <div className="addunit-header">
                    <h4 className="modal-title">
                      {actionType === "Restore" ? "Restore" : "Inactivate"} Role
                      Group
                    </h4>
                    <button
                      style={{ border: "none", backgroundColor: "inherit" }}
                      type="button"
                      className="close"
                      onClick={() => setConfirmModal(false)}
                    >
                      <img src={close} width="28px" height="28px" alt="Close" />
                    </button>
                  </div>
                  <div className="addunit-form">
                    <p>
                      Are you sure you want to{" "}
                      {actionType === "Restore" ? "restore" : "inactivate"} this
                      role group?
                    </p>
                  </div>
                  <div className="addunit-card-footer justify-content-between">
                    <button
                      type="button"
                      className="discard-btn"
                      onClick={() => setConfirmModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="update-btn"
                      onClick={confirmAction}
                    >
                      {actionType === "Restore" ? "Restore" : "Inactivate"}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Bulk Delete Modal */}
          <div
            id="overlay"
            className={`modal fade ${bulkDeleteModal ? "show" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{
              zIndex: 30,
              display: bulkDeleteModal ? "block" : "none",
              transition: "width 2s",
            }}
          >
            {loading ? (
              <Loader />
            ) : (
              <div>
                <div className="addunit-card Width 25%">
                  <div className="addunit-header">
                    <h4>Bulk Inactive</h4>
                    <button
                      style={{ border: "none", backgroundColor: "inherit" }}
                      type="button"
                      className="close"
                      onClick={() => setBulkDeleteModal(false)}
                    >
                      <img src={close} width="28px" height="28px" alt="Close" />
                    </button>
                  </div>
                  <div className="bulk-delete-unit">
                    <img src={recyclebin} width="48px" height="48px" />

                    <h4 className="delete-unit-h4">Inactive RoleGroups</h4>
                    <p className="delete-unit-text">
                      Are you sure you want to inactive all the selected role
                      groups?
                    </p>
                  </div>
                  <div className="addunit-card-footer justify-content-between">
                    <button
                      type="button"
                      className="discard-btn"
                      onClick={() => setBulkDeleteModal(false)}
                    >
                      CANCEL
                    </button>
                    <button
                      type="button"
                      className="update-btn"
                      onClick={handleBulkDelete}
                    >
                      CONFIRM
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <ToastContainer autoClose={2000} position={"top-right"} />
    </>
  );
};

export default RoleGroup;
